import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber, CountryCode } from 'libphonenumber-js/mobile';

export function emailPhoneNumberValidator(countryCode: CountryCode): ValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value) {
      return null
    };
    if (control.value.includes("@")) {
      return emailValidation(control.value);
    } else {
      return phoneNumberValidation(control.value, countryCode);
    };
  }
}

function phoneNumberValidation(phoneNumber:string, countryCode: CountryCode) : ValidationErrors | null {
  if (isValidPhoneNumber(phoneNumber, countryCode)) {
    return null;
  }
  return { 'notValidPhoneNumber': true }
};

function emailValidation(email:string): ValidationErrors | null {
  
  const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailPattern.test(email)) {
    return null;
  }
  return { 'notValidEmailAddress': true };
}

export function resetCodeValidator (control: AbstractControl): ValidationErrors | null {
  const resetCode = control.value;
  if (!resetCode) {
    return null
  };
  const resetCodePattern = /^[0-9]*$/;
  if (!resetCodePattern.test(resetCode)) {
    return { 'notValidNumber': true }
  }
  if (resetCode.length < 6) {
    return { 'codeIsTooShort': true }
  }
  if (resetCode.length > 6) {
    return { 'codeIsTooLong': true }
  }
  return null;
}
